import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../../common/GameFont";
import { MyWalletsBoxElementType } from "../wallets/MyWalletsBoxElementType";

export class MyWalletTypeView extends Container {
    private readonly commonResources: CommonResourcesPackage;

    private readonly icon: Sprite;
    private readonly text: Text;

    public constructor(commonResources: CommonResourcesPackage, authType: MyWalletsBoxElementType) {
        super();
        this.commonResources = commonResources;
        this.icon = new Sprite(this.commonResources.assets_common_favicon_png);
        this.text = new Text("IN-GAME WALLET", new WalletTextStyle());
        this.icon.width = this.icon.height = 76;
        this.addChild(this.icon, this.text);
        this.authType = authType;
    }

    public set authType(authType: MyWalletsBoxElementType) {
        switch (authType) {
            case MyWalletsBoxElementType.COINBASE: {
                this.icon.texture = this.commonResources.assets_common_ui_web3_coinbase_icon_png;
                this.text.text = 'COINBASE';
                break;
            }
            case MyWalletsBoxElementType.METAMASK: {
                this.icon.texture = this.commonResources.assets_common_ui_web3_metamask_icon_png;
                this.text.text = 'METAMASK';
                break;
            }
            case MyWalletsBoxElementType.THIRDWEB: {
                this.icon.texture = this.commonResources.assets_common_favicon_png;
                this.text.text = 'IN-GAME WALLET';
                break;
            }
        }
        this.icon.width = this.icon.height = 76;
        this.text.position.set(86, this.icon.height * 0.5 - this.text.height * 0.5);
    }
}

class WalletTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 48,
            fill: 'FFFFFF',
            trim: true
        });
    }
}
